export default __webpack_public_path__ + "static/media/elektra_steiger.27349ffd.svg";